import { defineStyleConfig, } from '@chakra-ui/react';
import { isTouchScreenDevice } from '../../theme-helper';
import { ThemeColorToken, ThemeFontToken } from '../theme-tokens';
const baseStyle = {
    color: ThemeColorToken.OnBackground,
    fontFamily: ThemeFontToken.Body,
    fontWeight: 'normal',
    textDecorationLine: 'underline',
    textUnderlineOffset: '3px',
    border: 0,
    _hover: {
        color: isTouchScreenDevice()
            ? ThemeColorToken.OnBackground
            : ThemeColorToken.AccentHover,
    },
    _active: {
        color: ThemeColorToken.AccentActive,
    },
};
export const linkConfig = defineStyleConfig({
    baseStyle,
});
//# sourceMappingURL=link-theme.js.map